export {};

function handleVerticalVideoMouseEnter(el: HTMLElement): void {
    if (!window.app) {
        return;
    }

    app.verticalVideoPreview.handleMouseEnter(el);
}

function handleVerticalVideoMouseLeave(el: HTMLElement): void {
    if (!window.app) {
        return;
    }

    app.verticalVideoPreview.handleMouseLeave(el);
}

window.handleVerticalVideoMouseEnter = handleVerticalVideoMouseEnter;
window.handleVerticalVideoMouseLeave = handleVerticalVideoMouseLeave;
